export const decode = (data: string) => atob(data);
export const encode = (data: string) => btoa(data);

export const pushState = (nextUrl: string) => {
  if (nextUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    history.pushState(undefined, '', nextUrl);
  }
};

export const createUrl = (urlSearchParams: URLSearchParams) => {
  const nextSearch = urlSearchParams.toString();
  const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${
    window.location.hash
  }`;
  return nextUrl;
};

export const sanitizeUrlSearchParams = (urlSearchParams: URLSearchParams) => {
  const nextUrlSearchParams = new URLSearchParams(urlSearchParams);
  nextUrlSearchParams.delete('hits');
  nextUrlSearchParams.delete('offset');
  if (nextUrlSearchParams.get('sort') === 'relevance') {
    nextUrlSearchParams.delete('sort');
  }
  return nextUrlSearchParams;
};
